skrilla.directive('systemDefaultDeposits',function() {
    return {
        templateUrl: 'directives/defaultDepositLimits/systemDefaultDeposits.html',
        scope: {
        },
        controller: function($scope, paginationService, queryService, searchService, modalService, currencyService){
            $scope.key = "nonDefaultDepositLimits"
            $scope.reset = function(){
                $scope.query = {limit: 20};
            }
            $scope.reset();


            $scope.showDefault = function(index){
                return $scope.defaultDeposits[index] && $scope.defaultDeposits[index].currency === $scope.tabs[$scope.defaultSelected].title;
            }

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getDefaults, $scope.key);
            }

            $scope.save = function(deposit){
                modalService.confirm("Are you sure you'd like to update the default deposit amounts?", function () {
                    const request =
                    {
                        maximumDailyDepositAmount : currencyService.multiply(deposit.maximumDailyDepositAmount, deposit.currency),
                        minimumDepositAmount : currencyService.multiply(deposit.minimumDepositAmount, deposit.currency),
                        currency: deposit.currency
                    }

                    searchService.put("limits/deposits/default", request, "Default Deposit Successfully updated!").then(function (response) {
                        $scope.defaultDeposits = response.data;
                        divideAmounts();
                    });
                });
            }

            var getDefaults = function() {
                return searchService.get("limits/deposits" + queryService.getQueryString($scope.query, $scope.key)).then(function(response) {
                    $scope.limits = response.data.result;
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

            searchService.get("limits/deposits/defaults").then(function (response) {
                $scope.defaultDeposits = response.data;
                divideAmounts();
            });

            function divideAmounts (){
                $scope.defaultDeposits.forEach(function (t) {
                    t.maximumDailyDepositAmount = currencyService.divide(t.maximumDailyDepositAmount, t.currency);
                    t.minimumDepositAmount = currencyService.divide(t.minimumDepositAmount, t.currency);
                })



            }

            $scope.search();
        }
    };
});
